import { formatDate } from '@angular/common';
import { Component, Inject, Input, OnInit, ViewChild, Output, EventEmitter, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicFormComponent } from 'src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component';
import { FieldConfig } from 'src/app/CommonComponents/dynamic-form/interface/field.interface';
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { CommonService } from 'src/app/Service/Common.service';
import { DocumentService } from 'src/app/Service/document/document.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { RestApiService } from 'src/app/Service/rest-api.service';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';
import { IDocSLNoInputModel, IDocumentInputModel, IDocumentLocInputModel, IDocumentRevInputModel, IElementInputModel, IDocumentByIdInputModel, DocumentOutputModel, IMSTOutputModel, IMSTDocDetailsInputModel, IMSTDetailsInputModel } from 'src/app/ViewModel/DocumentModel';
import { IProjectElementDetailsOutput, IProjectElementsOutput, IProjectFeatureOutput } from 'src/app/ViewModel/ProjectElementsModel';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import * as moment from 'moment';
import { Module } from 'src/app/Service/element-details.data.service';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { LoaderService } from 'src/app/Service/Loader/loader.service';
import { EIPAutoCompleteComponent } from 'eipauto-complete';
import { FileService, FileUploadLibrary } from 'src/app/Service/file/file.service';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { ProjectMasterService } from 'src/app/Service/projectmaster/projectmaster.service';
import { IProjectMasterViewModel } from 'src/app/ViewModel/ProjectMasterModel';
import { GridComponent } from '@progress/kendo-angular-grid';
import { Subscription } from 'rxjs/internal/Subscription';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Component({
  selector: 'app-document-inputs',
  templateUrl: './document-inputs.component.html',
  styleUrls: ['./document-inputs.component.css']
})
export class DocumentInputsComponent implements OnInit, OnDestroy {
  private _numFormat: string = 'Auto';
  @Input() docIndex: number = 0;
  @Input() docNosOf!: number;
  @Input() autoSerialNoMap: Map<number, number> = new Map<number, number>();
  @Input() set numFormat(val: string) {
    this._numFormat = val;
    if (val == 'Auto' || val == 'Manual') {
      this.readonly = true;
      this.isAutoEnabled = true;
      this.revisionInput(true);
    }
    else {
      this.readonly = false;
      this.isAutoEnabled = false;
      this.revisionInput(false);
    }
    this.enableDisableSerialNo(true);
  }
  get numFormat(): string {
    return this._numFormat;
  }
  @Input() readonly!: boolean;
  @Input() editDocument!: any;
  @Input() isEdit!: boolean;
  @Input() isSupersede!: boolean;
  @Output() isDocumentValid!: boolean;
  @Output() getDocumentSerialNo = new EventEmitter<any>();
  @Input() sourceDocComponent!: DocumentInputsComponent;
  @ViewChild("docSetForm") dynamicForm!: DynamicFormComponent;
  @ViewChildren(EIPAutoCompleteComponent) eipAutoCompleteComponents!: QueryList<EIPAutoCompleteComponent>;
  @ViewChild(GridComponent)
  private grid!: GridComponent;
  docnoreadonly: boolean = true;
  isShowSerialNo: boolean = true;
  serialNoLength: number = 5;
  public selectedDocument: any;
  public projectId: number = 0;
  public groupId: number = 0;
  public memberId: number = 0;
  public clickButton = true;
  public panelOpenState = true;
  public projectElements: IProjectElementsOutput[] = [];
  public isAutoEnabled: boolean = false;
  public regConfig: FieldConfig[] | null = [];
  public numElements: Map<string, string> = new Map<string, string>();
  public elementInp: IElementInputModel[] = [];
  public elementInput: IElementInputModel[] = [];
  public docRevInputModel: IDocumentRevInputModel[] = [];
  public printsizelist: IProjectElementDetailsOutput[] = [];
  public statusList: IProjectElementDetailsOutput[] = [];
  public approverList: IProjectFeatureOutput[] = [];
  public locationList: IProjectElementDetailsOutput[] = [];
  public buildingList: IProjectElementDetailsOutput[] = [];
  public floorList: IProjectElementDetailsOutput[] = [];
  public rackList: IProjectElementDetailsOutput[] = [];
  public shelfList: IProjectElementDetailsOutput[] = [];
  public DocId: number | null = null;
  public DocGroupId: number | null= null;
  public autoSerialNo!: string;
  public docSerialNo!: number | undefined;
  public docNo!: string;
  public documentNo!: string;
  public selectedPrintSize!: number | null;
  public selectedStatus!: number | null;
  public selectedLocation!: number | null;
  public selectedBuilding!: number | null;
  public selectedFloor!: number | null;
  public selectedRack!: number | null;
  public selectedShelf!: number | null;
  public titleTxt!: string;


  public selectedAuthorisedBy!: number | null;
  public isRevisedDateInvalid!: boolean;
  public isDocDateInvalid!: boolean;
  public datevalue = new Date(this.getDateFormat());
  public docdatevalue = new Date(this.getDateFormat());
  public RevisedOn: string = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
  public DocDate: string = formatDate(this.docdatevalue, 'dd-MM-yyyy', 'en-US');

  /*Set AutoComplete selected values for Edit*/
  public printSizeIndex: number = -1;
  public approverIndex: number = -1;
  public locationIndex: number = -1;
  public buildingIndex: number = -1;
  public floorIndex: number = -1;
  public rackIndex: number = -1;
  public shelfIndex: number = -1;
  public uid: number = 0;
  jobCode: string = '';
  mstList: IMSTOutputModel[] = [];
  mstNewList: IMSTDetailsInputModel[] = [];
  topSheetList: any[] = [];
  PONoList: any[] = [];
  MCodeList: any[] = [];
  topSheet_No !: string | null;
  PONo !: string | null;
  MaterialCode!: string | null;
  projectStaticElements: IProjectElementsOutput[] = [];
  isMSTIntegration: boolean = false;
  public selectedDocumentElements: IElementInputModel[] = [];
  field!: FieldConfig;

  public documentForm: FormGroup = new FormGroup({
    txtDocSerialNo: new FormControl(),
    txtSerialNo: new FormControl({ value: '', disabled: true }, [Validators.pattern("^[0-9]*$")]),
    lblIsConfidential: new FormControl(false),
    ddlPrintSize: new FormControl(),
    subDocumentType: new FormControl(),
    txtTitle: new FormControl(),
    autoPrintSize: new FormControl(),
    txtDocDate: new FormControl()
  });

  public revForm: FormGroup = new FormGroup({
    ddlStatus: new FormControl(),
    txtRevNo: new FormControl(),
    txtRevDate: new FormControl(),
    ddlAuthorisedBy: new FormControl(),
    txtRef: new FormControl(),
    txtQRCode: new FormControl(true),
    autoStatus: new FormControl(),
    dpRevDate: new FormControl(new Date),
    autoAuthorisedBy: new FormControl(),
    txtComments: new FormControl()
  });

  public locForm: FormGroup = new FormGroup({
    ddlLocation: new FormControl(),
    ddlBuilding: new FormControl(),
    ddlFloor: new FormControl(),
    ddlRack: new FormControl(),
    ddlShelf: new FormControl(),
    txtFileNo: new FormControl()
  });

  /**File List */
  public fileTypeList: RoleFeatureModel[] = [];
  public fileCollection: Array<any> = new Array<any>();

  private uris = {
    dedAgainstDEGetUrl: "DEDED/GetCommonDEDAgainstDE"
  };
  UnsubscribeArray: Subscription[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private _projService: ProjectInfoService,
    private _docService: DocumentService,
    private _notificationService: NotificationService,
    public restApiService: RestApiService,
    private commonService: CommonService,
    private _elementLinkService: ElementLinkService,
    private loaderService: LoaderService,
    private _fileService: FileService,
    private _projectService: ProjectMasterService) { }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.memberId = this.commonService.getLoggedInUserId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.uid = this.commonService.getLoggedInUserEipUserId();
    if (!this.isSupersede && !this.isEdit) {
      this.getDynamicForm();
    }
    if (this._numFormat == "Semi") {
      if (this.isEdit || this.isSupersede)
        this.documentForm.get('txtSerialNo')?.disable();
      else
        this.documentForm.get('txtSerialNo')?.enable();
    }
    this.getSerialNoLength();
    this.getprintsizelist();
    this.getStatusList();
    this.getApproverList();
    this.getLocationList();
    this.getBuildingList();
    this.getFloorList();
    this.getRackList();
    this.getShelfList();
    if (this.editDocument.docId != 0 && this.docIndex == 1) {
      this.DocId = this.editDocument.docId;
      this.DocGroupId = this.editDocument.docGroupId
      this.getDocumentDetails();
      this.getFileType();
      this.getFileList();
    }
    this.getProjectStaticElements();
    if (!!this.sourceDocComponent)
      this.copyGeneralDetails();
  }

  async getSerialNoLength() {
    let slNoArray = await this._elementLinkService.getNumberingSlNoLength(this.projectId, this.groupId, Module.UploadDocument).toPromise();
    this.serialNoLength = slNoArray.serialNoLength != 0 ? slNoArray.serialNoLength : 5;
  }

  ValidateForm() {
    this.isDocumentValid = this.documentForm.valid && this.revForm.valid && this.locForm.valid && !this.isRevisedDateInvalid && !this.isDocDateInvalid;
    if (!this.isDocumentValid) {
      this.formMarkAsTouched(this.dynamicForm.form);
      this.formMarkAsTouched(this.documentForm);
      this.formMarkAsTouched(this.revForm);
      this.formMarkAsTouched(this.locForm);
    }
    return this.isDocumentValid;
  }

  formMarkAsTouched(form: FormGroup) {
    if (!form.valid)
      Object.keys(form.controls).forEach(key => {
        form.get(key)?.markAsTouched();
      });
  }

  attachmentClick() {
    let docId = this.editDocument.docId;
    let revisionNo = this.editDocument.revisionNo;
    this.clickButton = true;
    const dialog = this.dialog.open(FileUploadComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '50%',
      data: { projectId: this.projectId, docId: docId, revisionNo: revisionNo, moduleName: 'EDMS', libraryName: FileUploadLibrary.Documents, createdBy: this.memberId, documents: [{ value: docId, text: this.getFormValue("txtDocSerialNo", this.documentForm), revisionNo: revisionNo, task_SNo: 0 }], isEditable: false },
    });

    dialog.afterClosed().subscribe((res: any) => {
      this.getFileList();
    });
  }

  collapseAllClick() {
    this.panelOpenState = !this.panelOpenState;
  }

  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }

  getDynamicForm() {
    let Getprojectelements = this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;
        this.regConfig = res.map(x => {
          let field: FieldConfig;
          let childDEId = null;
          let childDEDescription = "";
          let data = res.filter(item => item.dependentElementId == x.elementId);

          if (data.length > 0) {
            childDEId = data[0].elementId;
            childDEDescription = data[0].elementDescription;
          }

          field = {
            de_id: x.elementId,
            module_id: Module.UploadDocument,
            dependent_de_id: x.dependentElementId,
            dependent_de_Description: x.dependentElementDescription,
            child_de_id: childDEId,
            child_de_Description: childDEDescription,
            name: x.elementDescription,
            deDescription: x.elementDescription,
            type: 'select'
          }

          if (x.isMandatory) {
            field.validations = [
              {
                name: "required",
                validator: Validators.required,
                message: field.name + " Required"
              }
            ]
          }
          if (x.isNumbering) {
            this.numElements.set(x.elementDescription, '');
          }

          return field;
        });
        this.dynamicForm.fields = this.regConfig;
        this.dynamicForm.createControl();
        let resForm: FormGroup = this.dynamicForm.value;
        //Numbering elements array
        let numberingElements: string[] = Array.from(this.numElements.keys());
        numberingElements.forEach(element => {
          resForm.get(element)?.valueChanges.subscribe((x: any) => {

            if (this.numElements.has(element)) {
              if (!!x) {
                this.numElements.set(element, x.dedShortDescription);
              }
              else {
                this.numElements.set(element, '');
              }
            }
            if (this.numFormat == 'Auto' || this.numFormat == 'Semi') {
              this.GetDocumentSerialNo();
            }
          });
        });

        this.onCascadingAutocomplete_Change();

        if (!!this.sourceDocComponent)
          this.copyElementDetailsFromSource();
      });
    this.UnsubscribeArray.push(Getprojectelements);
  }

  onCascadingAutocomplete_Change() {
    if (this.regConfig)
      this.regConfig.forEach((data: any) => {
        if (!!data.child_de_id) {
          this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe((x: any) => {
            let resForm: FormGroup = this.dynamicForm.value;
            let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
            let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription)?.value;

            if (_field.length > 0 && !!parentControlSelectedValue) {
              this._projService.getProjectElementCascadingDetails({
                projectId: this.projectId,
                groupId: this.groupId,
                moduleId: Module.UploadDocument,
                deId: _field[0].de_id,
                deDescription: _field[0].deDescription,
                dependentDEId: _field[0].dependent_de_id,
                dependentDEDId: parentControlSelectedValue.dedId,
                memberId: this.memberId
              }).subscribe((res: IProjectElementDetailsOutput[]) => {
                if (res.length > 0) {
                  res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                  _field[0].values = res;
                }
                else {
                  _field[0].values = [];
                }
              }, (err: any) => { });
            }
            else {
              _field[0].values = [];
            }
          });
        }
      });
  }

  public getRepoDocNumber(): string {
    let docNo: string = this.getFormValue("txtDocSerialNo", this.documentForm);
    let serialNo: string = this.getFormValue("txtSerialNo", this.documentForm);
    if (this.numFormat == 'Auto' || this.numFormat == 'Semi') {
      if (!!serialNo && serialNo.trim().length > 0)
        return docNo + '-' + this.getFormValue("txtSerialNo", this.documentForm);
      else
        return docNo;
    }
    else
      return docNo;
  }


  /**
   * Bind Doc No
   */
  // bindDocIndex(i: number) {
  //   this.bindDocIndex = i + 1;
  // }
  /**
   * Get elementDetailsForm Controls value
   * @param controlName ControlName
   */
  getFormValue(controlName: string, formGroup: FormGroup): any {
    return formGroup.get(controlName)?.value;
  }
  /**
     *Get Document Serial No
     */
  GetDocumentSerialNo() {
    //Coin the Document number based on the element values selection changes
    let elementValues: string[] = Array.from(this.numElements.values());
    let selectedElementValues: string[] = elementValues.filter(val => val != '');
    this.docNo = elementValues.filter(val => val != '').join('-');
    this.documentForm.get('txtDocSerialNo')?.setValue(this.docNo);
    //Ensure all the mandatory numering elements selected
    if (elementValues.length > 0 && elementValues.length == selectedElementValues.length) {
      let resForm: FormGroup = this.dynamicForm.value;
      this.elementInp = this.projectElements.filter(x => x.isNumbering).map(x => {
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        let result: IElementInputModel = {
          deId: x.elementId,
          dedId: selectedValue.dedId,
          deDescription: x.elementDescription,
          dedDescription: selectedValue.dedDescription,
          dedShortDescription: selectedValue.dedShortDescription,
          sortBy: +selectedValue.sortBy
        }
        return result;
      });
      let inputModel: IDocSLNoInputModel = { projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, elementDetails: this.elementInp };
      let getdocSerial = this._docService.GetDocSerialNo(inputModel).subscribe((result: StandardOutputModel) => {
        //Updates the serial no based on remaining document selected ded ids
        this.getDocumentSerialNo.emit({ index: this.docIndex, selectedDedIds: this.elementInp, serialNo: result.successCode });
        //Set manipulated value from the parent component(W.r.t other documents elements selection while bulk upload)
        this.docSerialNo = this.autoSerialNoMap.get(this.docIndex);
        this.documentForm.get('txtSerialNo')?.setValue(String(this.docSerialNo).padStart(this.serialNoLength, '0'));
        this.enableDisableSerialNo(false);
      });
      this.UnsubscribeArray.push(getdocSerial);
    }
  }
  /**
   * Get Print Size
   */
  public async getprintsizelist() {
    let Getprintsize = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Print Size' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.printsizelist = res;
        if (!!this.sourceDocComponent) {
          let printSize = this.sourceDocComponent.documentForm.get('ddlPrintSize')?.value;
          if (!!printSize)
            this.selectedPrintSize = printSize;
          this.documentForm.get('autoPrintSize')?.setValue(this.printsizelist.filter(x => x.dedId == printSize)[0].dedDescription);
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(Getprintsize);
  }

  /**
   * Get Status List
   */
  public async getStatusList() {
    let statuslist = await this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Status' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.statusList = res;
        if (!!this.sourceDocComponent) {
          let status = this.sourceDocComponent.revForm.get('ddlStatus')?.value;
          if (!!status)
            this.selectedStatus = status;
          this.revForm.get('autoStatus')?.setValue(this.statusList.filter(x => x.dedId == status)[0].dedDescription);
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(statuslist);
  }

  /**
   * Get ApproverList List
   */
  public async getApproverList() {
    let approverlist = await this._projService.getProjectFeatureWiseMembers({ projectId: this.projectId, groupId: this.groupId, featureDescription: 'Approve' })
      .subscribe((res: IProjectFeatureOutput[]) => {
        this.approverList = res;
        if (!!this.sourceDocComponent) {
          let approver = this.sourceDocComponent.revForm.get('ddlAuthorisedBy')?.value;
          if (!!approver)
            this.selectedAuthorisedBy = approver;
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(approverlist);
  }

  /**
     * Get Location List
     */
  public async getLocationList() {
    let locationlist = await this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Location' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.locationList = res;
        if (!!this.sourceDocComponent) {
          let location = this.sourceDocComponent.locForm.get('ddlLocation')?.value;
          if (!!location)
            this.selectedLocation = location;
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(locationlist);
  }

  /**
   * Get Building List
   */
  public async getBuildingList() {
    let buildinglist = await this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Building' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.buildingList = res;
        if (!!this.sourceDocComponent) {
          let building = this.sourceDocComponent.locForm.get('ddlBuilding')?.value;
          if (!!building)
            this.selectedBuilding = building;
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(buildinglist);
  }

  /**
   * Get Floor List
   */
  public async getFloorList() {
    let floorlist = await this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Floor' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.floorList = res;
        if (!!this.sourceDocComponent) {
          let floor = this.sourceDocComponent.locForm.get('ddlFloor')?.value;
          if (!!floor)
            this.selectedFloor = floor;
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(floorlist);
  }

  /**
   * Get Rack List
   */
  public async getRackList() {
    let racklist = await this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Rack' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.rackList = res;
        if (!!this.sourceDocComponent) {
          let rack = this.sourceDocComponent.locForm.get('ddlRack')?.value;
          if (!!rack)
            this.selectedRack = rack;
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(racklist);
  }

  /**
   * Get Status List
   */
  public async getShelfList() {
    let shelflist = await this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, deDescription: 'Shelf' })
      .subscribe((res: IProjectElementDetailsOutput[]) => {
        this.shelfList = res;
        if (!!this.sourceDocComponent) {
          let shelf = this.sourceDocComponent.locForm.get('ddlShelf')?.value;
          if (!!shelf)
            this.selectedShelf = shelf;
        }
      }, (err: any) => { });
    this.UnsubscribeArray.push(shelflist);
  }

  getValue(selectedText: { value: any; }, field: string) {
    if (field == 'Revision Date') {
      this.isRevisedDateInvalid = selectedText.value == null;
      this.RevisedOn = selectedText.value;
    } else if (field == 'Document Date') {
      this.isDocDateInvalid = selectedText.value == null;
      this.DocDate = selectedText.value;
    }
  }
  getTimeValue(selectedText: any, field: any) {
  }

  setDocumentValues(event: { value: any; }, formControlName: string) {
    this.documentForm.get(formControlName)?.setValue(event.value);
  }
  setLocationValues(event: { value: any; }, formControlName: string) {
    this.locForm.get(formControlName)?.setValue(event.value);
  }
  setRevisionValues(event: { value: any; }, formControlName: string) {
    this.revForm.get(formControlName)?.setValue(event.value);
  }

  /**
  * Save Document
  */
  async saveDocument(): Promise<any> {
    let notificationShown = false;
    let result: DocumentOutputModel = { DocId: null, RevisionNo: "", DocAuthorizedBy: null, result: "", successCode: 400, successMessage: this.docIndex + " - " + "Mandatory fields are missing" };
    if (this.DocId == 0 || this.DocId == null) {
      let resForm: FormGroup = this.dynamicForm.value;
      this.elementInput = this.projectElements.map(x => {
        let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
        let selecetdMandatory = x.isMandatory;
        if(selecetdMandatory == true && selectedValue == null){
          this._notificationService.showToast("Mandatory fields are Required", "Warning");
          notificationShown = true;
          return null;
        }
        if (selectedValue != null) {
          let result: IElementInputModel = {
            deId: x.elementId,
            dedId: selectedValue.dedId,
            deDescription: x.elementDescription,
            dedDescription: selectedValue.dedDescription,
            dedShortDescription: selectedValue.dedShortDescription,
            sortBy: +selectedValue.sortBy
          }
          return result;
        }
      });
    }
      if (this.documentForm.valid && notificationShown == false) {
        let docRevInputModel: IDocumentRevInputModel = {
          DocId: this.DocId,
          RevisionNo: this.getFormValue('txtRevNo', this.revForm),
          DocStatus: this.getFormValue('ddlStatus', this.revForm),
          IsConfidential: this.getFormValue('lblIsConfidential', this.documentForm),
          PrintSize: this.getFormValue('ddlPrintSize', this.documentForm),
          Reference: this.getFormValue('txtRef', this.revForm),
          RevisedOn: this.RevisedOn,
          RevisionCategory: 1,
          DocAuthorizedBy: this.getFormValue('ddlAuthorisedBy', this.revForm),
          DocCreatedBy: this.memberId,
          Comments: this.getFormValue('txtComments', this.revForm),
          IsFileAttached: false,
          QRCodeStatus: this.getFormValue('txtQRCode', this.revForm),
          CreatedBy: this.memberId
        };
        let docLocInput: IDocumentLocInputModel = {
          DocId: this.DocId,
          RevisionNo: this.getFormValue('txtRevNo', this.revForm),
          Location: this.getFormValue('ddlLocation', this.locForm),
          Building: this.getFormValue('ddlBuilding', this.locForm),
          Floor: this.getFormValue('ddlFloor', this.locForm),
          Rack: this.getFormValue('ddlRack', this.locForm),
          Shelf: this.getFormValue('ddlShelf', this.locForm),
          FileNo: this.getFormValue('txtFileNo', this.locForm),
          UserId: this.memberId
        };
        let semiNo: string = '0';
        let docNo: string = this.getFormValue("txtDocSerialNo", this.documentForm);
        if (this.numFormat == 'Semi' || this.numFormat == 'Auto') {
          semiNo = this.getFormValue("txtSerialNo", this.documentForm);
          semiNo = semiNo.replace(/\D|^0+/g, "");
          if (!!semiNo && semiNo.length > 0)
            docNo = docNo + '-' + this.getFormValue("txtSerialNo", this.documentForm);
        }
        let inputModel: IDocumentInputModel = {
          DocId: this.DocId,
          DocNo: docNo,
          DocTitle: this.getFormValue('txtTitle', this.documentForm),
          DocDate: this.DocDate,
          ProjectId: this.projectId,
          GroupId: this.groupId,
          DocSerialNo: +semiNo,
          SchRevNo: 1,
          DocSheetNo: 1,
          Module: Module.UploadDocument,
          UserId: this.memberId,
          IsScheduled: false,
          elementDetails: this.elementInput,
          docRevInputs: docRevInputModel,
          docFLInputs: docLocInput
        };
        result = await this._docService.InsertDocument(inputModel).toPromise();


        if (!!this.isMSTIntegration) {
          if (result.successCode == 200 || result.successCode == 205) {

            let mstDocDetails: IMSTDocDetailsInputModel = {
              docId: +result.result,
              projectId: this.projectId,
              sSTDetails: this.mstNewList,
              userId: this.memberId

            }
            let result1: StandardOutputModel = await this._docService.InsertMSTDocDetails(mstDocDetails).toPromise();
          }
        }

        result = {
          DocId: +result.result,
          RevisionNo: this.getFormValue('txtRevNo', this.revForm),
          DocAuthorizedBy: this.getFormValue('ddlAuthorisedBy', this.revForm),
          result: result.result,
          successCode: result.successCode,
          successMessage: result.successMessage
        };
        return result;
      }
    else
      return Promise.resolve();
  }

  changeAutoStatus(event?: any) {
    if (event.checked || event == true) {
      this.revisionInput(true);
    }
    else {
      this.revisionInput(false);
    }
  }

  revisionInput(isChecked: boolean) {
    if (isChecked == true) {
      if (!this.isSupersede && !this.isEdit) {
        this.revForm.controls['txtRevNo'].setValue('0');
      }
      this.revForm.controls['txtRevNo'].disable();
      this.revForm.controls['txtRevDate'].disable();
      if (!!this.statusList && this.statusList.length > 0)
        this.statusList = [...this.statusList];
      this.revForm.controls['autoStatus'].updateValueAndValidity();
      this.selectedStatus = this.selectedStatus;
    }
    else {
      this.revForm.controls['txtRevNo'].enable();
      this.revForm.controls['txtRevDate'].enable();

    }
  }

  private enableDisableSerialNo(semiNoUpdateRequired: boolean) {
    this.isShowSerialNo = this.numFormat == 'Semi' || this.numFormat == 'Auto';
    if (!!this.documentForm) {
      if (this.numFormat == 'Auto') {
        this.docnoreadonly = true;
        this.documentForm.get('txtSerialNo')?.disable();
        this.documentForm.get('txtDocSerialNo')?.disable();
        if (semiNoUpdateRequired)
          this.GetDocumentSerialNo();
      }
      else if (this.numFormat == 'Semi') {
        this.docnoreadonly = true;
        this.documentForm.get('txtSerialNo')?.enable();
        this.documentForm.get('txtDocSerialNo')?.disable();
        if (semiNoUpdateRequired)
          this.GetDocumentSerialNo();
      }
      else if (this.numFormat == 'Manual') {
        this.docnoreadonly = false;
        this.documentForm.get('txtDocSerialNo')?.setValue('');
        this.documentForm.get('txtSerialNo')?.setValue('');
        this.documentForm.get('txtDocSerialNo')?.enable();
        this.documentForm.get('txtSerialNo')?.disable();
      }
    }
  }

  reSet() {
    this.printsizelist = [];
    this.statusList = [];
    this.approverList = [];
    this.locationList = [];
    this.buildingList = [];
    this.floorList = [];
    this.rackList = [];
    this.shelfList = [];
    this.selectedPrintSize = null;
    this.selectedStatus = null;
    this.selectedLocation = null;
    this.selectedBuilding = null;
    this.selectedFloor = null;
    this.selectedRack = null;
    this.selectedShelf = null;
    this.selectedAuthorisedBy = null;
    const txtTitleControl = this.documentForm.get('txtTitle');
    txtTitleControl.setValue(null);
    txtTitleControl.markAsPristine();
    txtTitleControl.markAsUntouched();

    const txtRefControl = this.revForm.get('txtRef');
    txtRefControl.setValue(null);
    txtRefControl.markAsPristine();
    txtRefControl.markAsUntouched();

    const txtCmntControl = this.revForm.get('txtComments');
    txtCmntControl.setValue(null);
    txtCmntControl.markAsPristine();
    txtCmntControl.markAsUntouched();

    const txtFileControl = this.locForm.get('txtFileNo');
    txtFileControl.setValue(null);
    txtFileControl.markAsPristine();
    txtFileControl.markAsUntouched();

    this.eipAutoCompleteComponents.forEach(x => x.clearText());
    this.ngOnInit();
  }

  collapsePanel() {
  }

  public getDocumentDetails() {
    let inputModel: IDocumentByIdInputModel = {
      projectId: this.projectId,
      groupId: this.DocGroupId ? this.DocGroupId : this.groupId,
      docId: this.editDocument.docId,
      revisionNo: this.editDocument.revisionNo
    };
    let getDocdetails = this._docService.getDocumentById(inputModel).subscribe(x => {
      this.selectedDocument = [];
      this.selectedDocument.push({
        docId: x['docId'],
        docNo: x['documentNo'],
        title: x['title'],
        docDate: formatDate(x['docDate'], 'dd-MM-yyyy', 'en-US'),
        revision: x['revision'],
        nextRevision: x['nextRevision'],
        printSize: x['printSize'],
        status: x['status'],
        createdBy: x['createdBy'],
        createdByName: x['createdByName'],
        authorizedBy: x['authorisedBy'],
        docAuthorizedByName: x['docAuthorizedByName'],
        createdOn: x['createdOn'],
        revisiedOn: formatDate(x['revisedOn'], 'dd-MM-yyyy', 'en-US'),
        reviewedOn: x['reviewedOn'],
        comments: x['comments'],
        reference: x['reference'],
        isFileAttached: x['isFileAttached'],
        qrCodeStatus: x['qrCodeStatus'],
        isConfidential: x['isConfidential'],
        location: x['location'],
        building: x['building'],
        floor: x['floor'],
        rack: x['rack'],
        shelf: x['shelf'],
        fileNo: x['fileNo']
      });
      this.getDocumentElements();
      this.docNo = x['documentNo'];
      this.documentForm.get('txtDocSerialNo')?.setValue(this.docNo);
      //While editing the document, no need to show the serial no 
      this.isShowSerialNo = false;
      this.documentForm.get('txtTitle')?.setValue(x['title']);
      this.documentForm.get('lblIsConfidential')?.setValue(x['isConfidential']);
      this.setSelectedPrintsize(x['printSize']);

      if (this.isSupersede) {
        this.revForm.get('txtRevNo')?.setValue(x['nextRevision']);
        let date = new Date();
        let startdate = moment(date, "DD/MM/YYYY");
        this.datevalue = startdate.toDate();
        this.RevisedOn = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
      }
      else {
        this.revForm.get('txtRevNo')?.setValue(x['revision']);
        let date = formatDate(x['revisedOn'], 'dd-MM-yyyy', 'en-US');
        let startdate = moment(date, "DD/MM/YYYY");
        this.datevalue = startdate.toDate();
        this.RevisedOn = formatDate(this.datevalue, 'dd-MM-yyyy', 'en-US');
      }

      let date = formatDate(x['docDate'], 'dd-MM-yyyy', 'en-US');
      let startdate = moment(date, "DD/MM/YYYY");
      this.docdatevalue = startdate.toDate();
      this.DocDate = formatDate(this.docdatevalue, 'dd-MM-yyyy', 'en-US');

      this.revForm.get('txtRef')?.setValue(x['reference']);
      this.setSelectedStatus(x['status']);
      this.setSelectedAuthorisedBy(x['authorisedBy']);
      this.setSelectedLocation(x['location']);
      this.setSelectedBuilding(x['building']);
      this.setSelectedFloor(x['floor']);
      this.setSelectedRack(x['rack']);
      this.setSelectedShelf(x['shelf']);
      this.locForm.get('txtFileNo')?.setValue(x['fileNo']);
      this.revForm.get('txtComments')?.setValue(x['comments']);
    });
    this.UnsubscribeArray.push(getDocdetails);
  }

  public setSelectedPrintsize(printSize: number) {
    this.selectedPrintSize = printSize;
    this.documentForm.get('autoPrintSize')?.setValue(printSize);
    this.documentForm.get('ddlPrintSize')?.setValue(printSize);
  }

  public setSelectedStatus(data: number) {
    this.selectedStatus = data;
    this.revForm.get('autoStatus')?.setValue(data);
    this.revForm.get('ddlStatus')?.setValue(data);
  }

  public setSelectedAuthorisedBy(data: number) {
    this.selectedAuthorisedBy = data;
    this.revForm.get('autoAuthorisedBy')?.setValue(data);
    this.revForm.get('ddlAuthorisedBy')?.setValue(data);
  }

  public setSelectedLocation(data: number) {
    this.selectedLocation = data;
    this.locForm.get('ddlLocation')?.setValue(data);
  }

  public setSelectedBuilding(data: number) {
    this.selectedBuilding = data;
    this.locForm.get('ddlBuilding')?.setValue(data);
  }

  public setSelectedFloor(data: number) {
    this.selectedFloor = data;
    this.locForm.get('ddlFloor')?.setValue(data);
  }

  public setSelectedRack(data: number) {
    this.selectedRack = data;
    this.locForm.get('ddlRack')?.setValue(data);
  }

  public setSelectedShelf(data: number) {
    this.selectedShelf = data;
    this.locForm.get('ddlShelf')?.setValue(data);
  }

  getDocumentElements() {
    let getdocElements = this._docService.getDocumentElementsById({ docId: this.editDocument.docId }).subscribe(
      (pde: IElementInputModel[]) => {
        this.selectedDocumentElements = pde;
        this.setDynamicForm();
      });
    this.UnsubscribeArray.push(getdocElements);
  }

  setDynamicForm() {
    let setdynamic = this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, IsQueryForStaticElement: false }).subscribe(
      (res: IProjectElementsOutput[]) => {
        this.projectElements = res;
        this.regConfig = res.map((x): FieldConfig => {
          let field: FieldConfig = { type: "label", label: x.elementDescription, de_id: x.elementId }
          if (this.selectedDocumentElements.length > 0) {
            let dedValue: any = this.selectedDocumentElements.find(el => el.deId == x.elementId)?.dedShortDescription + " - " + this.selectedDocumentElements.find(el => el.deId == x.elementId)?.dedDescription;
            field.value = new BehaviorSubject(dedValue);

          }
          return field;
        });
        this.dynamicForm.fields = this.regConfig;
        this.dynamicForm.createControl();
      });
    this.UnsubscribeArray.push(setdynamic);
  }

  private copyElementDetailsFromSource() {
    let sourceProjElementForm: FormGroup = this.sourceDocComponent.dynamicForm.value;
    this.projectElements.forEach(x => {
      let selectedValue: IProjectElementDetailsOutput = sourceProjElementForm.get(x.elementDescription)?.value;
      if (!!selectedValue) {
        let field: FieldConfig | undefined = this.regConfig ? this.regConfig.find(ele => ele.de_id == selectedValue.deId && ele.deDescription == selectedValue.deDescription) : undefined;
        if (!!field) {
          field.value = new BehaviorSubject(selectedValue.dedId);
        }
      }
    })
  }

  private copyGeneralDetails() {
    let sourceDocumentForm: FormGroup = this.sourceDocComponent.documentForm;
    let sourceRevForm: FormGroup = this.sourceDocComponent.revForm;

    let lblIsConfidential: boolean = sourceDocumentForm.get('lblIsConfidential')?.value;
    this.documentForm.get('lblIsConfidential')?.setValue(lblIsConfidential);

    let txtRef: string = sourceRevForm.get('txtRef')?.value;
    if (!!txtRef)
      this.revForm.get('txtRef')?.setValue(txtRef);

    let txtRevNo: string = sourceRevForm.get('txtRevNo')?.value;
    if (!!txtRevNo)
      this.revForm.get('txtRevNo')?.setValue(txtRevNo);

    let txtQRCode: boolean = sourceRevForm.get('txtQRCode')?.value;
    this.revForm.get('txtQRCode')?.setValue(txtQRCode);
  }

  public getFileList() {
    this.fileCollection = [];

    let fileInput = {
      projectId: this.projectId,
      docId: this.editDocument.docId,
      revisionNo: this.editDocument.revisionNo
    }
    let getfilelist = this._fileService.GetFiles({ libraryNumber: FileUploadLibrary.Documents, value: JSON.stringify(fileInput) }).subscribe(
      (data: any) => {
        let returnData = data;
        for (let index = 0; index < returnData['length']; index++) {
          this.fileCollection.push({
            serial: index + 1,
            fileId: returnData[index].fileId,
            fileName: returnData[index].fileName,
            fileSize: returnData[index].fileSize,
            fileExtension: returnData[index].fileExtension,
            fileFullName: returnData[index].fileName + '.' + returnData[index].fileExtension,
            uploadedBy: returnData[index].createdBy,
            uploadedByName: returnData[index].createdByName,
            uploadedOn: this.getFormattedDate(returnData[index].createdOn),
            fileType: returnData[index].fileType,
            fileTypeName: this.getFileTypeName(returnData[index].fileType),
            fileUrn: returnData[index].urn
          });
        }
      });
    this.UnsubscribeArray.push(getfilelist);
  }

  public getFormattedDate(date: moment.MomentInput) {
    let res;
    if (date != null) {
      res = (moment(date)).format('DD-MMM-yyyy');
    }
    return res;
  }

  public getFileType() {
    let reqData = { "DEDescription": "File Type" };
    return this.restApiService.new_POST(this.uris.dedAgainstDEGetUrl, reqData).subscribe((data: any) => {
      this.fileTypeList = data;
    });
  }

  public getFileTypeName(fileType: number) {
    if (this.fileTypeList.filter(item => item.dedId == fileType).length > 0)
      return this.fileTypeList.filter(item => item.dedId == fileType)[0]["dedDescription"];
    else
      return '';
  }

  public deleteFile(dataItem: { fileId: any; fileFullName: any; }) {
    this._notificationService.showPopup('Are you sure to delete', 'Confirm').then(data => {
      if (data == 'yes') {
        let deletefile = this._fileService.DeleteFile({ libraryNumber: FileUploadLibrary.Documents, fileId: dataItem.fileId, fileName: dataItem.fileFullName }).subscribe((res: StandardOutputModel) => {
          if (res.successCode === 200) {
            this._notificationService.showToast(res.successMessage, "Success");
          }
          else {
            this._notificationService.showToast(res.successMessage, "Warning");
          }
        });
        this.UnsubscribeArray.push(deletefile);
      }
    });
  }


  public downloadFile(dataItem: { fileId: any; fileFullName: string; }) {
    this.loaderService.isLoading.next(true);
    let downloadfile = this._fileService.DownloadFile({ libraryNumber: FileUploadLibrary.Documents, fileId: dataItem.fileId, fileName: dataItem.fileFullName }).subscribe((res: any) => {
      this.loaderService.isLoading.next(false);
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(res);
      downloadLink.download = dataItem.fileFullName;
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }, (err: any) => {
      this.loaderService.isLoading.next(false);
      this._notificationService.showToast("Error in downloading attachment, try after some time", "Warning");
    });
    this.UnsubscribeArray.push(downloadfile);
  }
  getMSTDetails() {
    this._projectService.getProjects(this.projectId, this.memberId).subscribe((data: IProjectMasterViewModel[]) => {
      this.jobCode = data[0].job_Code;
      let getmstdetails = this._docService.GetMSTDetails({ uid: this.uid, jobCode: this.jobCode })
        .subscribe((res: any) => {
          this.mstList = res;
          this.getTopSheetNoList();
        });
      this.UnsubscribeArray.push(getmstdetails);
    });
  }

  async getTopSheetNoList() {
    let mstList1 = this.mstList.map((element => {
      return { "topSheet_No": element.topSheet_No, "topsheet_Description": element.topsheet_Description };
    }));
    this.topSheetList = mstList1.reduce((accumalator: any, current) => {
      if (!accumalator.some(
        (item: any) => item.topSheet_No === current.topSheet_No)) {
        accumalator.push(current);
      }
      return accumalator;
    }, []);

  }

  TopSheetValueChange(val: any) {
    if (!!val.additionalValues.additionalValues) {
      this.topSheet_No = val.additionalValues.additionalValues.topSheet_No;
    }
    else {
      this.topSheet_No = null;
    }
    let mstList1 = this.mstList.filter(data => data.topSheet_No == this.topSheet_No);
    let poList1 = mstList1.map((element => {
      return { "pO_No": element.pO_No };
    }));
    this.PONoList = poList1.reduce((accumalator: any, current) => {
      if (!accumalator.some(
        (item: any) => item.pO_No === current.pO_No)) {
        accumalator.push(current);
      }
      return accumalator;
    }, [])
  }

  PONoValueChange(val: any) {
    if (!!val.additionalValues.additionalValues) {
      this.PONo = val.additionalValues.additionalValues.pO_No;
    }
    else {
      this.PONo = null;
    }
    let mstList1 = this.mstList.filter(data => data.topSheet_No == this.topSheet_No && data.pO_No == this.PONo);
    let mcList1 = mstList1.map((element => {
      return { "material_Code_Description": element.material_Code_Description, "material_Code": element.material_Code };
    }));
    this.MCodeList = mcList1;
  }

  ItemCodeValueChange(val: any) {
    if (!!val.additionalValues.additionalValues) {
      this.MaterialCode = val.additionalValues.additionalValues.material_Code;
    }
    else {
      this.MaterialCode = null;
    }
  }
  addMSTDocument() {
    let mstDocDetails: IMSTDetailsInputModel = {
      topSheetNo: this.topSheet_No,
      pONo: this.PONo,
      materialItemCode: this.MaterialCode,
      isActive: true
    }
    let checkMSTList = this.mstNewList.filter(x => x.topSheetNo == this.topSheet_No && x.pONo == this.PONo && x.materialItemCode == this.MaterialCode)
    if (checkMSTList.length == 0) {
      this.mstNewList.push(mstDocDetails);
      this.topSheet_No = null
      this.PONo = null
      this.MaterialCode = null
    }
    else {
      this._notificationService.showToast("Already Exists", "Warning");
      return;
    }
  }

  async getProjectStaticElements() {
    await this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.UploadDocument, IsQueryForStaticElement: true }).toPromise().then(
      (res: IProjectElementsOutput[]) => {
        if (res.length > 0) {
          this.projectStaticElements = res;
          let isMSTIntegrationElement = this.projectStaticElements.filter(x => x.elementDescription == "MST Integration")[0];
          if (!!isMSTIntegrationElement) {
            this.isMSTIntegration = isMSTIntegrationElement.isMandatory;
          }
        }
      }, (err: any) => {
        this._notificationService.showToast("failed to get static element details", "Warning");
      });
    if (this.isMSTIntegration)
      this.getMSTDetails();
  }

  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }

}
